export default {
    init() {
        setupHeader();
    }
}

function setupHeader() {
    let $header = $('#header');

    setupSubMenus($header);

    checkForWpAdminBar($header);
    $(window).smartresize(function(){
        checkForWpAdminBar($header);
    });

    $(window).on('scroll', function() {
        if (($header.outerHeight()) > $(this).scrollTop()) {
            $header.css('border-bottom-color', 'transparent')
        } else {
            $header.css('border-bottom-color', '#ced4e0');
        }
    });
}

function setupSubMenus($header) {
    $header.find('.nav').superfish();
}

function checkForWpAdminBar($header) {
    let $wpAdminBar = $('#wpadminbar');

    if($wpAdminBar.length) {
        $wpAdminBar.css('position', 'fixed');
        $header.css('top', $wpAdminBar.innerHeight() + 'px');
    }
}